import { Box, Button, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import SeasonSelect from "../components/SeasonSelect";
import { useAuth } from "../context/AuthContext";
import { getPageHeaderStyles } from "../theme/siteTheme";

interface PageHeaderProps {
  title: string;
  withStatistiksNav: boolean;
}

export const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  withStatistiksNav,
}: PageHeaderProps) => {
  const { isAuthenticated } = useAuth();
  const theme = useTheme();
  const styles = getPageHeaderStyles(theme);

  return (
    <Box>
      <Typography variant="h2" sx={{ mb: 3, mt: 1, textAlign: "center" }}>
        {title}
      </Typography>
      <Box sx={styles.actions}>
        <SeasonSelect />
        {withStatistiksNav && (
          <Button
            component="a"
            href="/statistics"
            variant="contained"
            sx={{
              ...styles.actionButton,
              ...styles.secondaryAction,
            }}
          >
            Zur Statistik
          </Button>
        )}
        {!isAuthenticated ? (
          <Button
            component="a"
            href="/management"
            variant="contained"
            sx={{
              ...styles.actionButton,
              ...styles.primaryAction,
            }}
          >
            Admin
          </Button>
        ) : (
          <Button
            component="a"
            href="/management"
            variant="contained"
            sx={{
              ...styles.actionButton,
              ...styles.primaryAction,
            }}
            onClick={() => {
              window.sessionStorage.removeItem("adminToken");
              window.sessionStorage.removeItem("adminUser");
              window.location.href = "/management";
            }}
          >
            Logout
          </Button>
        )}
      </Box>
    </Box>
  );
};
